import { render } from "./IconAlertCircle.vue.js?vue&type=template&id=4af40a7e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconAlertCircle.vue?vue&type=template&id=4af40a7e"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__